import React from "react";

import { RadioButtonGroupInput, required } from "react-admin";
import { extractRest } from "../../../../utils/extractRest";
import { withStyles } from "@material-ui/core/styles";

const styles = theme => ({
  flexDirectionOverride: {
    flexDirection: "column !important"
  }
});

const XlsFormFields = props => {
  const restProps = extractRest(props);
  return (
    <div className="form-fields">
      <div className="form-row">
        <div className="w-100">
          <RadioButtonGroupInput
            source="reporting_interval"
            options={{
              // props przekazywany do RadioGroup material-ui przez operator spread
              className: props.classes.flexDirectionOverride
            }}
            choices={[
              { id: "180_days", name: "xls.range_button.180_days" },
              { id: "90_days", name: "xls.range_button.90_days" },
              { id: "30_days", name: "xls.range_button.30_days" },
              { id: "7_days", name: "xls.range_button.7_days" }
            ]}
            validate={required()}
            {...restProps}
          />
        </div>
      </div>
    </div>
  );
};

export default withStyles(styles)(XlsFormFields);
